
export const TOFA_BACKGROUND_LIGHT_BLUE = '#ebf5ff'
